import { Box, BoxProps, Loader, ModalDialog, Spacer, Text, ColorOptions } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'
import { Header } from '../../components/Header'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { GenerateFileForm } from './GenerateFileForm'

const GenerateExcelFile = () => {
  const [isLoading, setLoading] = useState(false)
  const [isModal, setModal] = useState(false)
  const [data, setData] = useState({})
  const [selectedFile, setSelectedFile] = useState('')

  const navigation = useNavigation()

  const { fetchAllByFile, fetchFiles, fileNames, excelFile, generateExcel, fetchAllRules, accessConfig } = useStores(
    (store) => ({
      fetchAllByFile: store.generateExcelFile.fetchAllByFile,
      fetchFiles: store.generateExcelFile.fetchFiles,
      length: store.generateExcelFile.fileNames.length,
      fileNames: store.generateExcelFile.getFileNames(),
      generateExcel: store.generateExcelFile.generateFile,
      excelFile: store.generateExcelFile.getFileData(selectedFile),
      fetchAllRules: store.routingRule.fetchAllRules,
      accessConfig: store.user.getAccessConfig(['routing', 'rule_package_mapping']),
    }),
  )

  const [lazyFetchAllByFile, lazyFetchAllByFileHandler] = useLazyApiData(fetchAllByFile)
  const [lazyGenerate, lazyGenerateHandler] = useLazyApiData(generateExcel)
  const [lazyFetchFiles, lazyFetchFilesHandler] = useLazyApiData(fetchFiles)

  useFocusEffect(
    useCallback(() => {
      setSelectedFile('')
      lazyFetchFiles()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation]),
  )

  useFocusEffect(
    useCallback(() => {
      fetchAllRules()
    }, [fetchAllRules]),
  )

  useEffect(() => {
    if (lazyFetchAllByFileHandler.state === 'fulfilled' || lazyFetchAllByFileHandler.state === 'rejected') {
      setLoading(false)
    }
  }, [lazyFetchAllByFileHandler])

  const onPress = () => {
    if (excelFile) {
      setData(excelFile)
      setModal(true)
    }
  }

  const onAction = () => {
    console.log({ excelFile })
    lazyGenerate(excelFile)
  }

  const getMappingList = () => {
    if (!excelFile) {
      return null
    }
    return (
      <Box alignSelf="flex-start">
        <Box flexDirection="row">
          <Box flexDirection="row" alignItems="center">
            <Text type="h3Bold" color="BLACK_LIGHT">
              ID :
            </Text>
            <Spacer size={16} direction="horizontal" />
            <Text type="h2Bold" color="BLACK_21">
              {excelFile.id}
            </Text>
          </Box>
          <Spacer size={40} direction="horizontal" />
          <Box flexDirection="row" alignItems="center">
            <Text type="h3Bold" color="BLACK_LIGHT">
              File Name :
            </Text>
            <Spacer size={16} direction="horizontal" />
            <Text type="h2Bold" color="BLACK_21">
              {excelFile.fileName}
            </Text>
          </Box>
          <Spacer size={40} direction="horizontal" />
          <Box flexDirection="row" alignItems="center">
            <Text type="h3Bold" color="BLACK_LIGHT">
              Rules :
            </Text>
            <Spacer size={16} direction="horizontal" />
            <Text type="h2Bold" color="BLACK_21">
              {excelFile.rules}
            </Text>
          </Box>
        </Box>
        <Spacer size={16} />
        {isAccessible(accessConfig, 'update') && (
          <Box flexDirection="row" alignSelf="flex-end">
            <ButtonNew type="secondarySmall" borderColor="WHITE" title={'Edit'} onPress={onPress} />
            <Spacer size={8} direction="horizontal" />
            <ButtonNew
              type="primarySmall"
              title={'Generate Excel'}
              onPress={onAction}
              isLoading={lazyGenerateHandler.state === 'pending'}
              width={150}
            />
          </Box>
        )}
      </Box>
    )
  }

  const onAdd = () => {
    setData({})
    setModal(true)
  }

  const onFileSelected = (key: any, value: any) => {
    setLoading(true)
    setSelectedFile(value)
    lazyFetchAllByFile(value)
  }

  const onDismiss = () => {
    setModal(false)
  }

  return (
    <Box>
      <Header
        left={{ title: 'Generate Excel File', subtitle: ['', 'Generate Excel File'] }}
        right={{
          secondOnPress: isAccessible(accessConfig, 'add') && onAdd,
          secondTitle: 'Add File',
        }}
      />
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'fetch') && (
        <Box {...styles.listContainer}>
          <Text fontSize={16} fontFamily={'jiotype-bold'} color={'#214796' as ColorOptions}>
            Excel File
          </Text>
          <Spacer direction="vertical" size={16} />
          {lazyFetchFilesHandler.state === 'pending' && <Loader />}
          <Box alignItems="center" flexDirection="row">
            <Text type="h3Bold">FileName : </Text>
            <Spacer direction="horizontal" size={16} />
            <Dropdown
              value={selectedFile}
              data={fileNames}
              title={'-- choose fileName --'}
              fieldName={'fileName'}
              setFieldValue={onFileSelected}
            />
          </Box>
          <Spacer direction="vertical" size={16} />
          {isLoading && (
            <>
              <Loader />
              <Spacer size={16} />
            </>
          )}
          {selectedFile !== '' && getMappingList()}
        </Box>
      )}
      <ModalDialog
        children={
          <GenerateFileForm
            data={data}
            onUpdate={onDismiss}
            isDeletable={isAccessible(accessConfig, 'delete')}
            onClose={onDismiss}
          />
        }
        show={isModal}
        type={'Right'}
      />
    </Box>
  )
}

export default GenerateExcelFile

const styles = {
  container: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
  } as BoxProps,
  innerContainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
  listContainer: {
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
  } as BoxProps,
}
